import { LoadingScreen } from '@/components/loaders/LoadingScreen';
import { ROUTES } from '@/consts/routes';
import { useAuthStore } from '@/stores/useAuthStore';
import { Navigate } from 'react-router';

interface AuthGuardProps {
  children: React.ReactNode;
}

export const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const { isLoaded, isSignedIn, isLoadingUserData, user } = useAuthStore();

  if (!isLoaded) {
    return <LoadingScreen message="loading.session" />;
  }

  if (!isSignedIn) {
    return <Navigate to={ROUTES.auth.login} replace />;
  }

  if (isLoadingUserData) {
    return <LoadingScreen message="loading.userData" />;
  }

  // User is signed in with Clerk but doesn't exist in MD database
  if (user === null) {
    return <Navigate to={ROUTES.auth.unauthorized} replace />;
  }

  return <>{children}</>;
};
